import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

// Generic delete-confirmation dialog shared by every AdminComponents *ListConfirmDelete
// (they were all byte-for-byte identical except the title and the item's label).
const EntityConfirmDelete = ({ item, itemLabel, getLabel, onConfirm, onClose, open }) => {

    const handleConfirm = async () => {
        await onConfirm();
        onClose();
    }

    return (
        <div>
            <Dialog keepMounted open={open} onClose={onClose}>
                <DialogTitle>Supprimer {itemLabel}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Vous êtes sur le point de <strong>supprimer {getLabel(item)}</strong>.<br />
                        Etes vous sûr ?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">Annuler</Button>
                    <Button onClick={handleConfirm} color="primary">Confirmer</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

EntityConfirmDelete.propTypes = {
    item: PropTypes.object.isRequired,
    itemLabel: PropTypes.string.isRequired,
    getLabel: PropTypes.func,
    open: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

EntityConfirmDelete.defaultProps = {
    getLabel: (item) => item.name,
};

export default EntityConfirmDelete;
